import React from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { ButtonSplitGroup } from '@components/Buttons';
import { CheckoutTermsAndConditions } from '@components/Checkout/CheckoutTermsAndConditions';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { CancellationsCheckoutTable } from '@components/Order/Cancellations/CancellationsCheckoutTable';
import { EmptyCancellationCartModal } from '@components/Order/Cancellations/Modals';
import { Page500 } from '@containers/ErrorPages';
import { EmptyCart } from '@containers/Order/Cancellations/EmptyCart';
import { cancellationCartApi } from '@reducers/order/order';

export const Numbers = () => {
  const navigate = useNavigate();
  const { login } = useSelector((state) => state.auth.user);

  const [process] = cancellationCartApi.useProcessCartMutation();
  const cart = cancellationCartApi.useGetListQuery({ login });

  const schema = Yup.object().shape({
    termsAndConditions: Yup.boolean()
      .oneOf([true], 'Please accept Terms and Conditions to process order.')
      .required(),
  });

  if (cart.isLoading || cart.isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (cart.isError) {
    return <Page500 />;
  }
  if (!cart.data || cart.data.length === 0) {
    return <EmptyCart />;
  }

  return (
    <Card>
      <Card.Header className="bg-didxl text-white">
        Cancellations Cart Checkout
      </Card.Header>
      <Card.Body>
        <CancellationsCheckoutTable data={cart.data} />
        <Formik
          enableReinitialize
          validationSchema={schema}
          initialValues={{ termsAndConditions: false }}
          onSubmit={async (_, actions) => {
            actions.setSubmitting(true);
            process({ login })
              .unwrap()
              .then(() => {
                navigate(`/`);
              })
              .catch(() => {
                actions.setFieldError('name', 'Server-side error occurred.');
                actions.setSubmitting(false);
              });
          }}
        >
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit} className="mt-3">
              <CheckoutTermsAndConditions />
              <Row>
                <Col>
                  <ButtonSplitGroup>
                    <EmptyCancellationCartModal />
                    <Button
                      size="sm"
                      variant="didxl"
                      onClick={() => navigate('/numbers')}
                    >
                      Back to existing numbers
                    </Button>
                    <Button size="sm" type="submit" variant="didxl">
                      Process cancellation
                    </Button>
                  </ButtonSplitGroup>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
};
